import { render, staticRenderFns } from "./targetDetail.vue?vue&type=template&id=002723c8&scoped=true&"
import script from "./targetDetail.vue?vue&type=script&lang=js&"
export * from "./targetDetail.vue?vue&type=script&lang=js&"
import style0 from "./targetDetail.vue?vue&type=style&index=0&id=002723c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002723c8",
  null
  
)

export default component.exports